mutation TagGroupDelete($input: TagGroupDeleteInput!) {
  tagGroupDelete(input: $input) {
    deletedEntities {
      id
      rowTimestamp
    }
  }
}
